import { useCallback, useState } from "react"
import { Box, Button, Flex, Image, Input, Text, VStack } from "@chakra-ui/react"

import walletIcon from "#/assets/wallet.svg"

type AddressInputProps = {
  placeholder?: string
  buttonLabel?: string
  onButtonClick: (value: string) => void
  validate?: (value: string) => boolean
}

export default function AddressInput({
  placeholder = "Enter address",
  buttonLabel = "Save",
  onButtonClick,
  validate = () => true,
}: AddressInputProps) {
  const [address, setAddress] = useState("")
  const [hasError, setHasError] = useState(false)

  const buttonClickHandler = useCallback(() => {
    if (validate(address)) {
      onButtonClick(address)
    } else {
      setHasError(true)
    }
  }, [address, onButtonClick, validate])

  return (
    <VStack gap="10px" alignItems="start" position="relative">
      <Box
        border="1px solid"
        borderColor={hasError ? "primary.red.100" : "primary.black.100"}
        borderRadius="48px"
        bg="primary.white.100"
        w="100%"
        mb="13px"
      >
        <Flex alignItems="center">
          <Input
            onChange={(e) => {
              setHasError(false)
              setAddress(e.target.value)
            }}
            variant="unstyled"
            placeholder={placeholder}
            padding="12px 16px"
          />
          <Button
            isDisabled={hasError || !address}
            onClick={buttonClickHandler}
            marginRight="8px"
            leftIcon={<Image src={walletIcon} />}
            variant="primary"
            color="primary.black.100"
            p="4px 16px"
            h="32px"
            borderRadius="24px"
          >
            <Text variant="body">{buttonLabel}</Text>
          </Button>
        </Flex>
      </Box>
      {hasError && (
        <Text
          position="absolute"
          bottom="-20px"
          marginLeft="10px"
          variant="body"
          color="primary.red.100"
        >
          Address not accepted
        </Text>
      )}
    </VStack>
  )
}
